import React, { useEffect, useState } from 'react';

import { customBreadcrumbs } from '@app/store/actions';
import { useDispatch } from 'react-redux';
import { mainMenuTypes, IMenuItem } from '@app/components/Sidebar/menuObject';
import { getMenuItemById, infiniteScrollItemsFetchLimit, userReportsOptions } from '@app/helpers';
import { PageLoader, PasslySelect } from '@app/components';
import { useSetPage, useTypedTranslation } from '@app/hooks';
import { handleSetSnackbar } from '@app/store/actions/snackbar.actions';
import { IUser } from '@app/models';
import { MenuItem } from '@material-ui/core';
import { SelectInfiniteV2 } from '@app/componentsV2';
import { basicService, reportsService } from '@app/services';
import { AxiosResponse } from 'axios';
import { UserReports } from '@app/pages/reports/components';
import { Button } from '@itglue/kaseya-ui';

const ReportsPage = () => {
    const { translation } = useTypedTranslation();
    const item: IMenuItem | undefined = getMenuItemById(mainMenuTypes.Reports);
    const [errorMessage, setErrorMessage] = useState('');
    const [isShowLoader, setIsShowLoader] = useState(false);
    const [isShowUsersSelect, setIsShowUsersSelect] = useState(false);
    const [selectsValues, setSelectsValues] = useState({
        userReportSelected: '',
        userSelected: '',
        passwordReportSelected: '',
        vaultReportSelected: ''
    });
    const [users, setUsers] = useState<IUser[]>([]);
    const [usersCount, setUsersCount] = useState(0);
    const [generateUserReports, setGenerateUserReports] = useState(0);
    const showUserReports = basicService.isDefaultOrgBeta() && basicService.orgFeaturePasswordServerEnabled();

    const dispatch = useDispatch();

    const handleError = (error: any) => {
        setIsShowLoader(false);
        setErrorMessage(error.response.data.message);
    };

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setSelectsValues((previousState) => ({ ...previousState, [name]: value }));
    };

    const handleGenerateReport = () => {
        reportsService.userReportsLog(selectsValues.userSelected, selectsValues.userReportSelected);
        setGenerateUserReports(generateUserReports + 1);
    };

    useSetPage(null, item);

    useEffect(() => {
        dispatch(
            customBreadcrumbs([
                {
                    name: translation('REPORT_MANAGER')
                }
            ])
        );
    }, []);

    useEffect(() => {
        setIsShowUsersSelect(!!selectsValues.userReportSelected);
    }, [selectsValues.userReportSelected]);

    useEffect(() => {
        if (errorMessage) {
            dispatch(handleSetSnackbar({ show: true, message: errorMessage, severity: 'error' }));
        }
    }, [errorMessage]);

    const fetchMoreUsersData = (skipCount: number, currentOrgId: string, isReset: boolean) => {
        reportsService
            .getUsersForReports(skipCount, infiniteScrollItemsFetchLimit)
            .then((res: AxiosResponse) => {
                if (res.data.items && !isReset) {
                    setUsers((previousState: any) => previousState.concat(res.data.items));
                }

                if (isReset) {
                    setUsers(res.data.items);
                    setUsersCount(res.data.count);
                }
            })
            .catch(handleError);
    };

    return (
        <div className='reports'>
            <main className='reports__content'>
                <h1 className='header--h1'>{translation('REPORT_MANAGER')}</h1>

                {showUserReports ? (
                    <>
                        <div className='reports__help-text'>{translation('REPORT_MANAGER_HELPER_TEXT')}</div>

                        <div className='reports__item'>
                            <div className='reports__controls-block'>
                                <PasslySelect
                                    name='userReportSelected'
                                    value={selectsValues.userReportSelected}
                                    onChange={handleChange}
                                    id='user-reports'
                                    label={'REPORT_MANAGER_SELECT_LABEL_1'}
                                    placeholder={translation('REPORT_MANAGER_SELECT_REPORT_PLACEHOLDER')}
                                    options={userReportsOptions}
                                    optionLabel='label'
                                    optionValue='value'
                                />
                                {isShowUsersSelect ? (
                                    <div className='reports__item--user'>
                                        <SelectInfiniteV2
                                            className='reports__user-selected'
                                            name='userSelected'
                                            value={selectsValues.userSelected}
                                            onChange={handleChange}
                                            id='users'
                                            label={'USER'}
                                            placeholder={'REPORT_MANAGER_SELECT_USER_PLACEHOLDER'}
                                            onFetch={fetchMoreUsersData}
                                            totalCount={usersCount}
                                            currentCount={users.length}
                                        >
                                            {users.map((item: any) => (
                                                <MenuItem key={item.userId} value={item.userId}>
                                                    {`${item.userDisplayName} (${item.organizationName})`}
                                                </MenuItem>
                                            ))}
                                        </SelectInfiniteV2>
                                    </div>
                                ) : null}

                                {selectsValues.userReportSelected && selectsValues.userSelected ? (
                                    <div className='reports__button-block'>
                                        <Button className='reports__item--use' variant='primary' autoWidth={true} onClick={handleGenerateReport}>
                                            {translation('DARKWEB_COMPROMISE_BUTTON_GENERATE_REPORT')}
                                        </Button>
                                    </div>
                                ) : null}
                            </div>
                            {selectsValues.userReportSelected && selectsValues.userSelected && generateUserReports ? (
                                <UserReports
                                    userReportSelected={selectsValues.userReportSelected}
                                    userSelected={selectsValues.userSelected}
                                    resetLocal={generateUserReports}
                                />
                            ) : null}
                        </div>
                    </>
                ) : null}

                {/*<div className='reports__item'>
                    <PasslySelectV2
                        name='passwordReportSelected'
                        value={selectsValues.passwordReportSelected}
                        onChange={handleChange}
                        id='password-reports'
                        label={'REPORT_MANAGER_SELECT_LABEL_2'}
                        placeholder={'REPORT_MANAGER_SELECT_REPORT_PLACEHOLDER'}
                    >
                        {passwordReportsOptions.map((item: any) => (
                            <MenuItem key={item.value} value={item.value}>
                                {translation(item.label)}
                            </MenuItem>
                        ))}
                    </PasslySelectV2>
                </div>
                <div className='reports__item'>
                    <PasslySelectV2
                        name='vaultReportSelected'
                        value={selectsValues.vaultReportSelected}
                        onChange={handleChange}
                        id='vault-reports'
                        label={'REPORT_MANAGER_SELECT_LABEL_3'}
                        placeholder={'REPORT_MANAGER_SELECT_REPORT_PLACEHOLDER'}
                    >
                        {vaultReportsOptions.map((item: any) => (
                            <MenuItem key={item.value} value={item.value}>
                                {translation(item.label)}
                            </MenuItem>
                        ))}
                    </PasslySelectV2>
                </div>*/}
            </main>
            {isShowLoader && <PageLoader useOverlay={true} />}
        </div>
    );
};

export default ReportsPage;
